import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Bot, ChevronDown, LogOut, Server, Settings, ShieldCheck, Swords, Trophy, Upload, UserRound } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import navigation from '../config/site-navigation.json'
import { useAuth } from '../contexts/AuthContext'
import { Logo } from './Logo'
import { Button } from './ui'

export function SiteHeader() {
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const displayName = auth.user?.display_name || auth.user?.wechat_nickname || auth.user?.username

  return <header className="site-header">
    <Logo />
    <nav className="main-nav" aria-label="主导航">
      {navigation.map(item => {
        const active = item.paths.includes(location.pathname)
        return <Link className={active ? 'active' : undefined} key={item.href} to={item.href}>{item.label}</Link>
      })}
    </nav>
    <div className="header-actions">
      {auth.loading ? <span className="header-loading">加载中</span> : auth.user ? <DropdownMenu.Root>
        <DropdownMenu.Trigger className="user-trigger"><UserRound size={17}/><span className="user-name" title={displayName}>{displayName}</span><ChevronDown size={14}/></DropdownMenu.Trigger>
        <DropdownMenu.Portal><DropdownMenu.Content className="dropdown-content" align="end" sideOffset={8}>
          <DropdownMenu.Item onSelect={() => navigate('/submit/regular')}><Upload size={16}/>常规上传</DropdownMenu.Item>
          <DropdownMenu.Item onSelect={() => navigate('/submit/competition')}><Trophy size={16}/>赛事投稿</DropdownMenu.Item>
          <DropdownMenu.Item onSelect={() => navigate('/console')}><Settings size={16}/>开发者控制台</DropdownMenu.Item>
          {auth.user.is_admin && <><DropdownMenu.Separator /><DropdownMenu.Item onSelect={() => navigate('/admin/agents')}><Bot size={16}/>Agent 管理</DropdownMenu.Item><DropdownMenu.Item onSelect={() => navigate('/admin/assets')}><Server size={16}/>资产管理</DropdownMenu.Item><DropdownMenu.Item onSelect={() => navigate('/admin/competitions')}><Swords size={16}/>比赛管理</DropdownMenu.Item><DropdownMenu.Item onSelect={() => navigate('/admin')}><ShieldCheck size={16}/>平台设置</DropdownMenu.Item></>}
          <DropdownMenu.Separator />
          <DropdownMenu.Item onSelect={() => navigate('/account')}><ShieldCheck size={16}/>账号设置</DropdownMenu.Item>
          <DropdownMenu.Item className="danger" onSelect={() => void auth.logout()}><LogOut size={16}/>退出登录</DropdownMenu.Item>
        </DropdownMenu.Content></DropdownMenu.Portal>
      </DropdownMenu.Root> : <><Button onClick={() => auth.openAuth('wechat')}>登录</Button><Button variant="secondary" onClick={() => auth.openAuth('register')}>注册</Button></>}
    </div>
  </header>
}
